import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './Accordion.css'; // Ensure to create this CSS file for additional styling

const AccordionItem = ({ title, children, isExpanded, onToggle }) => {
  return (
    <div
      style={{
        border: 'none',
        boxShadow: '0 0 1px white',
        padding: '0.5rem',
        borderRadius: '1rem',
      }}
    >
      <h2>
        <button
          onClick={onToggle}
          style={{
            display: 'flex',
            justifyContent: 'space-between', // Aligns content to left and right
            alignItems: 'center', // Vertically center the content
            background: 'transparent',
            color: 'white',
            border: 'none',
            padding: '15px', // Added padding for a better clickable area
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: 'bold',
            width: '100%',
          }}
        >
          <span style={{ textAlign: 'left' }}>{title}</span>
          {/* Left-aligned text */}
          <span>{isExpanded ? '−' : '+'}</span>
        </button>
      </h2>
      <motion.div
        initial={{ opacity: 0, height: 0 }} // Initial state
        animate={
          isExpanded
            ? { opacity: 1, height: 'auto' }
            : { opacity: 0, height: 0 }
        } // Animation based on expansion state
        exit={{ opacity: 0, height: 0 }} // Close animation
        transition={{
          duration: 0.3, // Adjusted duration for smoother animation
          ease: [0.5, 0.05, 0.1, 0.3], // Smooth easing function
        }}
        style={{ overflow: 'hidden' }} // Prevent content from showing during height animation
      >
        <div style={{ padding: '15px', color: 'white' }}>{children}</div>
      </motion.div>
    </div>
  );
};

const Accordion = () => {
  const [expandedStates, setExpandedStates] = useState([
    false,
    false,
    false,
    false,
    false,
    false,
  ]);

  const toggleAccordion = (index) => {
    setExpandedStates((prevStates) =>
      prevStates.map((isExpanded, idx) =>
        idx === index ? !isExpanded : isExpanded
      )
    );
  };

  return (
    <div className='widthsetter'>
      <AccordionItem
        title='Do you offer packages, or is pricing customized?'
        isExpanded={expandedStates[0]}
        onToggle={() => toggleAccordion(0)}
      >
        We offer both fixed packages and customized solutions. If our standard
        packages don’t suit your needs, we can design a plan tailored to your
        requirements.
      </AccordionItem>
      <AccordionItem
        title='Can you handle the content for all social media platforms?'
        isExpanded={expandedStates[1]}
        onToggle={() => toggleAccordion(1)}
      >
        Absolutely! We manage content for platforms like Instagram, Facebook,
        LinkedIn, Twitter, and YouTube, ensuring cohesive branding and
        consistent growth across all channels.
      </AccordionItem>
      <AccordionItem
        title='Do you provide video editing services only?'
        isExpanded={expandedStates[2]}
        onToggle={() => toggleAccordion(2)}
      >
        Yes, we offer standalone video editing services for clients who need
        professional editing for their YouTube videos or other platforms.
      </AccordionItem>
      <AccordionItem
        title='How do you manage operational tasks for clients?'
        isExpanded={expandedStates[3]}
        onToggle={() => toggleAccordion(3)}
      >
        We assist in handling marketing operations like scheduling posts,
        responding to engagement, and tracking analytics so that you can focus
        on your day-to-day business activities.
      </AccordionItem>
      <AccordionItem
        title='How will outsourcing these tasks benefit my business?'
        isExpanded={expandedStates[4]}
        onToggle={() => toggleAccordion(4)}
      >
        By delegating marketing and operational tasks to us, you can save time
        and focus on needle-moving activities that directly impact your business
        growth.
      </AccordionItem>
      <AccordionItem
        title=' Can you help me with YouTube growth?'
        isExpanded={expandedStates[5]}
        onToggle={() => toggleAccordion(5)}
      >
        Yes, we specialize in YouTube content creation, editing, and optimization to help your channel grow organically.
        This includes thumbnail creation, video SEO, and analytics tracking.
      </AccordionItem>
    </div>
  );
};

export default Accordion;
